import gql from 'graphql-tag';

const UPDATE_SIM_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $simNumber: String!) {
    updateSim(deviceSerialNo: $deviceSerialNo, simNumber: $simNumber) {
      code
    }
  }
`;

export default UPDATE_SIM_DEVICE;
